// Add SCs_one.search.trackers_one.* tracking code here…
(function(SCS, debug) {
    'use strict';

    // jshint camelcase: false
    /* GetValOnce */
    function scGetValOnce(value, fieldname) {
        if (window.sessionStorage.getItem(fieldname) && String(value) === window.sessionStorage.getItem(fieldname)) return '';
        else {
            window.sessionStorage.setItem(fieldname, value);
            return value;
        }
    }

    // hotplugs for s_one functions
    var hotplug = {
        // apply item to list of not exists
        apl: function(array, item) {
            var narray = array;
            if (array.indexOf(item) < 0) narray.push(item); // push item if not in array
            return narray;
        },
        // cookie read
        c_r: function(a) {
            var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
            return b ? b.pop() : 'undefined';
        }
    };

    var search = SCS.search = SCS.search || {};
    search.trackers = search.trackers || {};
    // Define track logic as functions that can be called from the listeners

    function querySearch(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            if (object.requester !== 'user' || object.origin !== 'serp' || object.page > 0 || object.fromFilterChange) return;

            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.context['SERP'] = 'SERP_resultpage'; // this eVar should be present in all SERP pages, total seconds spent / instances = average
            trackObj.apps.search.events = ['searchQuery'];
            if (object.query) {
                trackObj.apps.search.context['SERP.query'] = object.query;
                if (scGetValOnce(object.query, 'SERP_query') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'newQueryTerm'); // every new query fires event
            }
            if (object.baseURL) trackObj.apps.search.context['SERP.baseURL'] = object.baseURL;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
            if (object.backendType) trackObj.apps.search.context['SERP.backendType'] = object.backendType;
            if (object.resultCount) trackObj.apps.search.context['SERP.resultCount'] = object.resultCount;
            if (object.site) trackObj.apps.search.context['SERP.site'] = object.site;
            if (object.client) trackObj.apps.search.context['SERP.client'] = object.client;
            if (object.language) trackObj.apps.search.context['SERP.language'] = object.language;
            if (object.filter.Area) trackObj.apps.search.context['SERP.filter.Area'] = object.filter.Area;
            if (object.filter.Category) trackObj.apps.search.context['SERP.filter.Category'] = object.filter.Category;

            var sViCookie = hotplug.c_r('s_vi');
            if (sViCookie !== 'undefined') trackObj.apps.search.context['SERP.s_vi'] = sViCookie.replace('[CS]v1|', '').replace('[CE]', '');

            if (object.ssid && object.site) {
                trackObj.apps.search.context['SERP.ssid'] = object.ssid;
                var tmp3 = scGetValOnce(object.ssid, 'SERP_ssid');
                debug.log('value cookievalues:' + tmp3);
                debug.log(object);
                if (tmp3 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstQueryInSession'); // only the first search is been counted
            }

            SCS.datalayer.track(trackObj);
        })(object));
    }

    function resultlinktracking(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.events = ['resultPageClick'];
            trackObj.apps.search.context['SERP'] = 'SERP_resultclick';

            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.ctype) {
                trackObj.apps.search.context['SERP.ctype'] = object.ctype;
                if (object.ctype === 'c' || object.ctype === 'ac' || object.ctype === 'keymatch') {
                    trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'searchResultEntryClick'); // every click on a result in the middle (ctype c) is counted
                }
            }
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;

            var sViCookie = hotplug.c_r('s_vi');
            if (sViCookie !== 'undefined') trackObj.apps.search.context['SERP.s_vi'] = sViCookie.replace('[CS]v1|', '').replace('[CE]', '');

            var tmp4;
            debug.log('object.site:' + object.site + ' object.ssid:' + object.ssid);
            if (object.ssid && object.site) {
                if (object.ctype === 'c' || object.ctype === 'ac' || object.ctype === 'keymatch') {
                    if (scGetValOnce(object.query, 'SERP_query_result') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstClickOnNewQueryTerm'); // only the first click for the query is been counted
                    tmp4 = scGetValOnce(object.ssid, 'SERP_ssid_result');
                    if (object.query && scGetValOnce(object.query, 'SERP_query') !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'newQueryTerm'); // every new query fires event
                    debug.log('value cookievalues: ' + tmp4);
                    if (tmp4 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstClickOnSearchResult'); // only the first click on a result (ctype c or ac) is counted
                }
                if (object.ctype === 'ac' || object.ctype === 'keymatch') {
                    trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'searchQuery'); //every query is tracked
                    trackObj.apps.search.context['SERP'] = 'SERP_query_resultpage'; // this eVar should be present in all SERP pages, total seconds spent / instances = average; override original value because of autocomplete detection
                    if (object.query) trackObj.apps.search.context['SERP.query'] = bject.query;
                    if (object.userQuery) trackObj.apps.search.context['SERP.userQuery'] = object.userQuery;
                    if (object.baseURL) trackObj.apps.search.context['SERP.baseURL'] = object.baseURL;
                    if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
                    if (object.backendType) trackObj.apps.search.context['SERP.backendType'] = object.backendType;
                    if (object.resultCount) trackObj.apps.search.context['SERP.resultCount'] = object.resultCount;
                    if (object.site) trackObj.apps.search.context['SERP.site'] = object.site;
                    if (object.client) trackObj.apps.search.context['SERP.client'] = object.client;
                    if (object.language) trackObj.apps.search.context['SERP.language'] = object.language;
                    if (object.filter.Area) trackObj.apps.search.context['SERP.filter.Area'] = object.filter.Area;
                    if (object.filter.Category) trackObj.apps.search.context['SERP.filter.Category'] = object.filter.Category;

                    tmp4 = scGetValOnce(object.ssid, 'SERP_ssid');
                    debug.log('value cookievalues:' + tmp4);
                    debug.log(object);
                    if (tmp4 !== '') trackObj.apps.search.events = hotplug.apl(trackObj.apps.search.events, 'firstQueryInSession'); // only the first search is been counted
                }
            }
            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    function noResultsFound(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            if (object.requester !== 'user' || object.origin === 'header') return;

            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.events = ['noResults'];
            trackObj.apps.search.context['SERP'] = 'SERP_noresult';

            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.query) trackObj.apps.search.context['SERP.query'] = object.query;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;

            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    function automaticSpellingCor(object) {
        window.SCS.tiq.trackingReadyCallbacks.push((function(object) {
            var trackObj = SCS.datalayer.cloneMandatoryData();
            trackObj.apps = trackObj.apps || {};
            trackObj.apps.search = {};
            trackObj.apps.search.context = {};
            trackObj.apps.search.events = [];

            trackObj.apps.search.context['SERP'] = 'SERP_autoSpellingCorrection';
            if (object.ssid) trackObj.apps.search.context['SERP.ssid'] = object.ssid;
            if (object.sessionSequence) trackObj.apps.search.context['SERP.sessionSequence'] = object.sessionSequence;
            if (object.origin) trackObj.apps.search.context['SERP.origin'] = object.origin;
            if (object.endpointURL) trackObj.apps.search.context['SERP.endpointURL'] = object.endpointURL;
            if (object.previousQuery) trackObj.apps.search.context['SERP.autoCorrection.previousQuery'] = object.previousQuery;
            if (object.query) trackObj.apps.search.context['SERP.autoCorrection.newQuery'] = object.query;

            SCS.datalayer.track(trackObj);
            debug.log(object);
        })(object));
    }

    search.trackers.sc = {
        generalClick: resultlinktracking,
        searchQuery: querySearch,
        noResults: noResultsFound,
        automaticSpellingCorrection: automaticSpellingCor
    };
})
(window.SCS = window.SCS || {}, window.debug);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/sc.js
// module id = 52
// module chunks = 0